const initialState = [{ name: "dani" }, { name: "efi" }, { name: "erfan" }];
const albumReducer = (state = initialState, action) => {
  if (action.type === "INIT_ALBUMS") {
    console.log("albumreducer", action);
    const albums = action.payload.map((item) => {
      return {
        id: item.id,
        song: item.url,
        poster: "img1 url",
        name: item.name,
        visited: item.visited,
      };
    });
    return albums;
  }
  return state;
};
export default albumReducer;
